export const MINECRAFT_MODERN_LIBRARY = {
    version: 'Camp Tecnologico extension/index.js · API minecraft_* · WebSocket bridge',
    nameEn: 'Minecraft newer (Camp API · extension/index.js)',
    nameEs: 'Minecraft mas nuevo (API Camp · extension/index.js)',
    descriptionEn: 'Camp Tecnologico Minecraft extension from extension/index.js (not the stock Scratch Bedrock build). Replaces the active Minecraft bar.',
    descriptionEs: 'Extension Minecraft de Camp Tecnologico (extension/index.js), distinta a la integrada generica de Scratch. Sustituye la barra activa de Minecraft.'
};

export const MINECRAFT_LEGACY_LIBRARY = {
    version: 'RaspberryJamMod · Minecraft Java 1.12.2',
    nameEn: 'Minecraft Legacy (RaspberryJamMod · Java 1.12.2)',
    nameEs: 'Minecraft Viejo (RaspberryJamMod · Java 1.12.2)',
    descriptionEn: 'Classic toolbox for RaspberryJamMod on Minecraft Java 1.12.2. Replaces the active Minecraft bar.',
    descriptionEs: 'Barra clasica para RaspberryJamMod en Minecraft Java 1.12.2. Sustituye la barra activa de Minecraft.'
};
